module.exports = __webpack_public_path__ + "static/img/pop_goods.0004820.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pop_goods.png
// module id = 3hY8
// module chunks = 1